var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82182 12.6447C4.40489 12.6447 4.04797 12.4962 3.75106 12.1993C3.45415 11.9024 3.3057 11.5455 3.3057 11.1285V2.03175C3.3057 1.61482 3.45415 1.2579 3.75106 0.960988C4.04797 0.664079 4.40489 0.515625 4.82182 0.515625H11.6444C12.0613 0.515625 12.4183 0.664079 12.7152 0.960988C13.0121 1.2579 13.1605 1.61482 13.1605 2.03175V11.1285C13.1605 11.5455 13.0121 11.9024 12.7152 12.1993C12.4183 12.4962 12.0613 12.6447 11.6444 12.6447H4.82182ZM4.82182 11.1285H11.6444V2.03175H4.82182V11.1285ZM1.78957 15.6769C1.37263 15.6769 1.01571 15.5285 0.7188 15.2316C0.421892 14.9346 0.273438 14.5777 0.273438 14.1608V3.54788H1.78957V14.1608H10.1283V15.6769H1.78957Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.d02fe51d1c3c7c8c9d3b910b30014689.svg";
export { ForwardRef as ReactComponent };